import React from "react";
import { Link } from "react-router-dom";

interface Props {
    to?: string;
    className?: string;
    style?: React.CSSProperties;
    target?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

export const SmartLink: React.FC<Props> = ({ to, ...props }) => {
    if (to) {
        if (to.includes("//")) {
            return <a href={to} {...props} />;
        }
        return <Link to={to} {...props} />;
    }
    return <button {...props} />;
};
